import fetchAPI from '../../../../../lib/utils/fetch-api'

interface SetPaymentProps {
  date: string,
  reason_id: number,
  comment: string,
}

export const setShippingDate = async (id: string | number, formData: SetPaymentProps, signal) => {
  try {
    const response = await fetchAPI(`/api/logistics/deliveries/shipment/${id}`, {
      method: 'POST',
      body: JSON.stringify(formData),
      signal,
    })

    if (response['errors']) {
      let error = response['errors']
      if (Array.isArray(error)) {
        error = error.join()
      }
      throw new Error(error)
    }

    return response
  } catch (err) {
    throw(err)
  }
}
